import React from "react";
import {
  Button,
  makeStyles,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@material-ui/core";
import { useSelector, useDispatch } from "react-redux";
import {
  setearContactoEditDelete,
  setOpenDeleteModal,
  setOpenCreateEditModal,
  contratacionesContactoDelete,
} from "../../../actions/contrataciones/contratacionesContactos";
import { validarSoloUnPermiso } from "../../../helpers/permisos";
import { CONTRATACIONES_CONTACTOS_CONTRATOS, CONTRATACIONES_LEGALES_PERMISOS } from "../../../utils/permisos";
import TableGeneric from "../../compartidos/abms/TableGeneric";

const RenderEditButton = ({ item }) => {
  const dispatch = useDispatch();

  return (
    <strong>
      <Button
        variant="contained"
        color="primary"
        size="small"
        style={{ marginLeft: 16 }}
        onClick={() => {
          dispatch(setearContactoEditDelete(item));
          dispatch(setOpenCreateEditModal(true));
        }}
      >
        Editar
      </Button>
    </strong>
  );
};

const RenderDeleteButton = ({ item }) => {
  const dispatch = useDispatch();

  return (
    <strong>
      <Button
        variant="contained"
        color="secondary"
        size="small"
        style={{ marginLeft: 16 }}
        onClick={(e) => {
          dispatch(setearContactoEditDelete(item));
          dispatch(setOpenDeleteModal(true));
        }}
      >
        Borrar
      </Button>
    </strong>
  );
};

const useStyles = makeStyles((theme) => ({
  root: {
    borderRadius: "4px",
    backgroundColor: theme.palette.background.paper,
    height: "55vh",
    width: "100%",
  },
}));

export const ContactoContratacionesItem = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { items: localidades } = useSelector((state) => state.localidades);
  const { items: provincias } = useSelector((state) => state.provincias);
  const { contactoEditDelete, openDeleteConfirmModal } = useSelector((state) => state.contratacionesContactos);
  const { permisos: permisosUser } = useSelector((state) => state.auth);

  const contactosFormateados = props.contactos.map((contacto) => {
    return {
      id: contacto.idEfectorContacto,
      id_tipo_contacto: contacto.tipoContacto.idTipoContacto,
      tipoContacto: contacto.tipoContacto.descripcion,
      nombreApellido: contacto.nombreApellido,
      cargo: contacto.cargo,
      email: contacto.email,
      interno: contacto.interno,
      telefono: contacto.telefono,
      telCelular: contacto.celular,
      calle: contacto.calle,
      nro: contacto.nro,
      piso: contacto.piso,
      depto: contacto.depto,
      cp: contacto.cp,
      id_localidad: parseInt(contacto.idLocalidad),
      localidad: localidades.find(
        (localidad) => localidad.id_localidad === parseInt(contacto.idLocalidad)
      )?.descripcion_localidad,
      id_provincia: parseInt(contacto.idProvincia),
      provincia: provincias.find(
        (provincia) => provincia.id_provincia === parseInt(contacto.idProvincia)
      )?.descripcion_provincia,
      observaciones: contacto.observaciones,
    };
  });

  // useEffect(() => {
  //   if (props.disabled) {
  //     columns = columns().filter((column) => column.field !== "colDeleteButton" && column.field !== "colEditButton");
  //   }
  // }, []);

  return (
    <React.Fragment>
      <Dialog
        open={openDeleteConfirmModal}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title">
          {"Eliminar contacto"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            Desea eliminar este contacto de forma permanente?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={(e) => {
              dispatch(contratacionesContactoDelete(contactoEditDelete?.id));
              dispatch(setOpenDeleteModal(false));
            }}
            color="primary"
          >
            Aceptar
          </Button>
          <Button
            onClick={(e) => {
              dispatch(setOpenDeleteModal(false));
            }}
            color="primary"
          >
            Cancelar
          </Button>
        </DialogActions>
      </Dialog>
      <div className={classes.root}>
        <TableGeneric
          data={contactosFormateados || []}
          columns={[
            {
              label: "Tipo de Contacto",
              id: "tipoContacto",
              sort: true
            },
            {
              label: "Nombre y Apellido",
              minWidth: 250,
              id: "nombreApellido",
              sort: true
            },
            {
              label: "Cargo",
              sort: true,
              id:"cargo"
            },
            {
              label: "Email",
              id: "email",
              minWidth: 250,
              sort: false
            },
            {
              label: "Interno",
              id: "interno",
              sort: false
            },
            {
              label: "Tel. Particular",
              minWidth: 150,
              id: "telefono",
              sort: false
            },
            {
              label: "Tel. Celular",
              minWidth: 150,
              id: "telCelular",
              sort: false
            },
            {
              label: "Calle",
              id: "calle",
              sort: false
            },
            {
              label: "Nro",
              id: "nro",
              sort: false
            },
            {
              label: "Depto",
              id: "depto",
              sort: false
            },
            {
              label: "CP",
              id: "cp",
              sort: false
            },
            {
              label: "Localidad",
              id: "localidad",
              sort: true
            },
            {
              label: "Provincia",
              id: "provincia",
              sort: true
            },
            {
              label: "Observaciones",
              minWidth: 250,
              id: "observaciones",
              sort: false
            },
            {
              label: "",
              customBody: item => (validarSoloUnPermiso(permisosUser, CONTRATACIONES_CONTACTOS_CONTRATOS.MODIFICACION) && !props.disabled) && validarSoloUnPermiso(permisosUser, CONTRATACIONES_LEGALES_PERMISOS.ADMINISTRAR) && <RenderEditButton item={item} />
            },
            {
              label: "",
              customBody: item => (validarSoloUnPermiso(permisosUser, CONTRATACIONES_CONTACTOS_CONTRATOS.BAJA) && !props.disabled) && <RenderDeleteButton item={item} />
            },
          ]}
        />
      </div>
    </React.Fragment>
  );
};
